import { Routes, Route, Navigate } from "react-router-dom";
import { StudentLayout } from "../layouts";
import { useAuth } from "../hooks";
import {
  Dashboard,
  MyCourses,
  MediaShow,
  MyPayments,
  Forum,
  LiveClass,
  MyGrades,
  Post,
  Support,
  MyNotifications,
  MyProfile,
  AIChat,
  InstitutionalDocuments,
} from "../pages/student";

export function StudentRouter() {
  const { user } = useAuth();

  const loadLayout = (Layout, Page) => {
    return (
      <Layout>
        <Page />
      </Layout>
    );
  };

  return (
    <Routes>
      <Route
        path="/login/*"
        element={<Navigate to="/student/dashboard" replace />}
      />
      <Route
        path="/admin/*"
        element={<Navigate to="/student/dashboard" replace />}
      />
      {["/student", "/student/dashboard"].map((path) => (
        <Route
          key={path}
          path={path}
          element={loadLayout(StudentLayout, Dashboard)}
        />
      ))}
      <Route
        path="/student/myCourses"
        element={loadLayout(StudentLayout, MyCourses)}
      />
      <Route
        path="/student/myCourses/:syllabuSubjectGradeId"
        element={loadLayout(StudentLayout, MediaShow)}
      />
      <Route path="/student/forum" element={loadLayout(StudentLayout, Forum)} />
      <Route
        path="/student/post/:postId"
        element={loadLayout(StudentLayout, Post)}
      />
      <Route
        path="/student/liveClasses"
        element={loadLayout(StudentLayout, LiveClass)}
      />
      <Route
        path="/student/extraCourses"
        element={loadLayout(StudentLayout, Dashboard)}
      />
      <Route
        path="/student/myPayments"
        element={loadLayout(StudentLayout, MyPayments)}
      />
      <Route
        path="/student/myGrades"
        element={loadLayout(StudentLayout, MyGrades)}
      />
      <Route
        path="/student/academicHistory"
        element={loadLayout(StudentLayout, Dashboard)}
      />
      <Route
        path="/student/support"
        element={loadLayout(StudentLayout, Support)}
      />
      <Route
        path="/student/myNotifications"
        element={loadLayout(StudentLayout, MyNotifications)}
      />
      <Route
        path="/student/myProfile"
        element={loadLayout(StudentLayout, MyProfile)}
      />
      <Route
        path="/student/aiChat"
        element={loadLayout(StudentLayout, AIChat)}
      />
      <Route
        path="/student/institutional-documents"
        element={loadLayout(StudentLayout, InstitutionalDocuments)}
      />
    </Routes>
  );
}
